
        <div class="row">
            <div class="col-4 text-center">
                <img class="img-avatar img-avatar32 mt-5 mr-5" src="{{params.value.logoUrl}}" onError="this.src='/assets/img/avatars/company.jpg';">
            </div>
            <div class="col-8">
                <a [routerLink]="['/companies', params.value.companyId]">{{ params.value.companyName }}</a>
            </div>
        </div>
    


// WEBPACK FOOTER //
// ./client/app/shared/grid/cell-renderers/company-cell-renderer.component.ts.CompanyCellRendererComponent.html